import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import AppSidebar from './AppSidebar';
import AppTopBar from './AppTopBar';
import AppBottomNav from './AppBottomNav';
import { useAppState } from '../hooks/useAppState';
import { useMediaQuery } from '../hooks/useMediaQuery';

/**
 * AppShell — the application chrome wrapping every authenticated module page.
 * Left: collapsible sidebar. Right: topbar (breadcrumbs + account) + <Outlet/>.
 *
 * On mobile (<= $bp-lg): the sidebar becomes an off-canvas drawer opened via a
 * topbar hamburger or the "Lainnya" bottom tab; a bottom tab bar is shown.
 */
export default function AppShell() {
  const { navbarCollapsed, toggleNavbarCollapsed, theme, toggleTheme } = useAppState();
  const isMobile = useMediaQuery('(max-width: 1024px)');
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const closeMobileNav = () => setMobileNavOpen(false);

  // Desktop-only sidebar collapse; on mobile the drawer is always expanded.
  const desktopCollapsed = navbarCollapsed && !isMobile;

  return (
    <div
      className={`app-shell${desktopCollapsed ? ' app-shell--collapsed' : ''}${
        mobileNavOpen ? ' app-shell--mobile-nav-open' : ''
      }`}
    >
      <AppSidebar
        collapsed={desktopCollapsed}
        onToggle={toggleNavbarCollapsed}
        onMobileClose={closeMobileNav}
      />

      <div
        className="app-shell__mobile-backdrop"
        onClick={closeMobileNav}
        aria-hidden="true"
      />

      <div className="app-shell__main">
        <AppTopBar theme={theme} onToggleTheme={toggleTheme} onOpenMobileNav={() => setMobileNavOpen(true)} />
        <main className="app-shell__content">
          <Outlet />
        </main>
      </div>

      <AppBottomNav onOpenMore={() => setMobileNavOpen(true)} />
    </div>
  );
}
